import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import { ModalAction } from 'model/modal.model';
import { Dispatch, useEffect, useState } from 'react';
import zeplinColor from 'theme/Color';
import style from './Component.module.css';
import CustomTextField from 'components/shared/CustomTextField/CustomTextField';
import CustomAutocomplete from 'components/shared/CustomAutocomplete/CustomAutocomplete';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { get } from 'http';
import { getAssigneeDropdown } from 'store/slices/leadsSlice';
import { LeadsService } from 'service/leads.service';
const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
    },
  },
};
export default function CustomConvertModal({
  isModalOpen,
  modalDispatch,
  onConvert,

  item,
}: {
  isModalOpen: boolean;
  modalDispatch: Dispatch<ModalAction>;
  onConvert: () => void;

  item: any;
}) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xl'));
  const dispatch = useAppDispatch();
  const { assigneeDropdown } = useAppSelector((state) => state.leads);
  const [formValues, setFormValues] = useState<Record<string, string>>({});
  const [isConverting, setIsConverting] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState({
    salutation: [] as string[],
    recordType: ['Talent', 'Athlete', 'Business Development'] as string[],
  });
  const [selectedItems, setSelectedItems] = useState<{
    ownerName: { Name: string; Id: string }[];
  }>({
    ownerName: [],
  });
  const handleClose = () => {
    if (!isConverting) modalDispatch({ type: 'CLOSE', payload: 'convert' });
  };
  const handleSelectChange = (key: string) => (event: any) => {
    setFormValues((prev) => ({ ...prev, [key]: event.target.value }));
  };

  const handleValueChange =
    (key: string) =>
    (event: React.ChangeEvent<HTMLInputElement> | { target: { value: string } }) => {
      setFormValues((prev) => ({ ...prev, [key]: event.target.value }));
    };
  const handleAssignSelection = (value: any) => {
    setSelectedItems((prev) => ({ ...prev, ownerName: value ? [value] : [] }));
  };
  const convertLeadToClient = async () => {
    try {
      setIsConverting(true);
      await LeadsService.convertLeadToClient(item.leadId, {
        name: formValues.name,
        salutation: formValues.salutation,
        recordType: formValues.recordType,
        ownerName: selectedItems.ownerName[0]?.Name || '',
      });
      onConvert();
    } catch (error) {
    } finally {
      setIsConverting(false);
    }
  };
  const leaddropdown = async () => {
    try {
      const response = await LeadsService.getLeadTypeDropdowns(item?.leadTypeName || '');
      dispatch(getAssigneeDropdown());

      setDropdownOptions((prev: any) => ({
        ...prev,
        salutation: response.salutation || [],
      }));
    } catch (error) {
      console.log({ error });
    }
  };
  const disabled = isConverting || !(formValues?.name && selectedItems?.ownerName?.[0]);

  useEffect(() => {
    if (item && isModalOpen) {
      leaddropdown();
      dispatch(getAssigneeDropdown());
      setFormValues({
        name: item.name || '',
        salutation: item.salutation || '',
        leadStatus: item.leadStatus || '',
      });
      setSelectedItems({
        ownerName: item.ownerName ? [item.ownerName] : [],
      });
    }
  }, [item?.leadId, isModalOpen]);
  return (
    <CustomModal handleClose={handleClose} open={isModalOpen}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '16px',
            width: '490px',
            padding: { xs: '20px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            display: 'flex',
            gap: '24px',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant='responsiveHeading3'>Convert Lead to Client</Typography>
            <img
              src={'/assets/close-icon.svg'}
              className={style['icon']}
              alt='close'
              style={{ cursor: 'pointer' }}
              onClick={handleClose}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Typography variant='responsiveBody2'>Create New Account</Typography>
            <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
              <FormControl sx={{ width: '100%', flex: 1 }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  size={isXs ? 'small' : 'medium'}
                  sx={{
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    fontSize: isXs ? 14 : 16,
                  }}
                >
                  Salutation
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  size={isXs ? 'small' : 'medium'}
                  value={formValues?.salutation || ''}
                  onChange={handleSelectChange('salutation')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          borderColor: zeplinColor.Neutral9,
                        },
                      }}
                      label='Salutation'
                    />
                  }
                  renderValue={(selected) =>
                    `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`
                  }
                  MenuProps={MenuProps}
                  IconComponent={() => <img src='/assets/down-arrow.svg' width={24} height={24} />}
                >
                  {dropdownOptions.salutation.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Radio
                        checked={formValues.salutation === name}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': { color: zeplinColor.BasicBlack },
                        }}
                      />
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <CustomTextField
                style={{ flex: 3 }}
                name='Name'
                text={formValues?.name || ''}
                form
                label='Name'
                type='text'
                onChange={handleValueChange('name')}
                required
              />
            </Box>
            <FormControl sx={{ flex: 1 }}>
              <InputLabel
                id='lead-status-label'
                size={isXs ? 'small' : 'medium'}
                sx={{ '&.Mui-focused': { color: zeplinColor.Neutral9 }, fontSize: isXs ? 14 : 16 }}
              >
                Record type
              </InputLabel>
              <Select
                labelId='lead-status-label'
                size={isXs ? 'small' : 'medium'}
                value={formValues.recordType || ''}
                onChange={handleSelectChange('recordType')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Lead Status'
                  />
                }
                renderValue={(selected) =>
                  `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`
                }
                MenuProps={MenuProps}
                IconComponent={() => <img src='/assets/down-arrow.svg' width={24} height={24} />}
              >
                {dropdownOptions.recordType.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={formValues.recordType === name}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': { color: zeplinColor.BasicBlack },
                      }}
                    />
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box sx={{ flex: 1 }}>
              <CustomAutocomplete
                required={false}
                options={assigneeDropdown || []}
                getOptionLabel={(option: any) => option?.Name ?? ''}
                label='Record owner'
                handleDeleteItems={() => {}}
                selectedItems={selectedItems}
                handleSelection={handleAssignSelection}
                value={selectedItems.ownerName[0]}
                handleFilter={() => {}}
                placeholder='Record owner'
                currentLength={assigneeDropdown.length}
                totalLength={assigneeDropdown.length}
                next={() => {}}
                multiple={false}
              />
            </Box>
          </Box>
          <CustomButton
            disabled={disabled}
            onClick={convertLeadToClient}
            variant={'contained'}
            color={'primary'}
            style={{
              borderRadius: '14px',
              height: 56,

              width: '100%',
              border: 'none',
              backgroundColor: disabled ? zeplinColor.Neutral3 : zeplinColor.Brand1,
            }}
            textStyle={{
              color: disabled ? zeplinColor.Neutral8 : zeplinColor.Neutral1,
            }}
            text={'Convert to Client'}
          />
        </CustomCard>
      </Box>
    </CustomModal>
  );
}
